import React, { FunctionComponent } from 'react';
import styled, { css } from 'styled-components';
import { Button } from 'react-bootstrap';

import {
  LIGHT_BLUE,
  PRIMARY_BLUE,
  BACKGROUND_GREY,
  BORDER_GREY,
  ERROR_RED,
  PRIMARY_GREY
} from 'constants/colours';

const StyledSelectionButton = styled(Button)<{
  selected: boolean;
  $hasError: boolean;
  disabled: boolean;
  $isLinearScale?: boolean;
  $small?: boolean;
}>(
  ({ selected, $hasError, disabled, $isLinearScale = false, $small = false }) => css`
    ${$isLinearScale &&
    `
      padding: 16px;
      width: 48px;
      height: 48px;
    `}

    ${$small &&
    `
      min-height: 32px;
      height: 32px;
      padding: 8px;
      border-radius: 8px !important;
    `}
    
    background: ${selected ? LIGHT_BLUE : BACKGROUND_GREY} !important;
    border: 1.5px solid
      ${(): string => {
        if ($hasError) return ERROR_RED;
        return selected ? PRIMARY_BLUE : BORDER_GREY;
      }} !important;
    border-radius: 4px;

    color: ${selected ? PRIMARY_BLUE : PRIMARY_GREY} !important;
    margin: 8px 8px 0 0;

    ${!disabled &&
    `&:hover {
      background: ${selected ? LIGHT_BLUE : BACKGROUND_GREY} !important;
      border-color: ${PRIMARY_BLUE} !important;
    }`}

    :disabled {
      pointer-events: none;
    }
  `
);

interface SelectionButtonProps {
  id?: string;
  item: string;
  onClick: () => void;
  selected?: boolean;
  hasError?: boolean;
  disabled?: boolean;
  isLinearScale?: boolean;
  small?: boolean;
}

const SelectionButton: FunctionComponent<React.PropsWithChildren<SelectionButtonProps>> = ({
  id = null,
  item,
  onClick,
  selected = false,
  hasError = false,
  disabled = false,
  isLinearScale = false,
  small = false
}) => (
  <StyledSelectionButton
    key={id || item}
    id={id}
    selected={selected}
    $hasError={hasError}
    onClick={onClick}
    data-selected={selected}
    disabled={disabled}
    $isLinearScale={isLinearScale}
    $small={small}
  >
    {item}
  </StyledSelectionButton>
);

export default SelectionButton;
